import { createAction } from '@reduxjs/toolkit';
import { WebCatalogProduct, WebCatalogDigitalProduct } from '../../utils/services/EveryDoggyAPITypes';

interface IProductDetailsOnInitPayload {
  name: string;
  details: WebCatalogProduct & { oldPrice?: string };
}

export enum DATA_ACTION_TYPES {
  SET_PAYMENT_PRODUCT = 'SET_PAYMENT_PRODUCT',
  SET_PRODUCT_ON_INIT_SCREEN = 'SET_PRODUCT_ON_INIT_SCREEN',
  SET_PAYMENT_CARD_BRAND = 'SET_PAYMENT_CARD_BRAND',
  CLEAN_STRIPE_ERRORS = 'CLEAN_STRIPE_ERRORS',
  SET_QUICK_PAYMENT = 'SET_QUICK_PAYMENT',
  SET_TARIFF = 'SET_TARIFF',
  SET_DIGITAL_PRODUCT = 'SET_DIGITAL_PRODUCT',
  SET_PAYMENT_FREE_BONUS = 'SET_PAYMENT_FREE_BONUS',
}

export const setPaymentProduct = createAction<string>(DATA_ACTION_TYPES.SET_PAYMENT_PRODUCT);
export const setProductDetailsOnInitScreen = createAction<IProductDetailsOnInitPayload>(
  DATA_ACTION_TYPES.SET_PRODUCT_ON_INIT_SCREEN
);
export const setPaymentCardBrand = createAction<string>(DATA_ACTION_TYPES.SET_PAYMENT_CARD_BRAND);
export const cleanUpStripeErrors = createAction<boolean>(DATA_ACTION_TYPES.CLEAN_STRIPE_ERRORS);
export const setQuickPayment = createAction<boolean>(DATA_ACTION_TYPES.SET_QUICK_PAYMENT);
export const setTariff = createAction<string>(DATA_ACTION_TYPES.SET_TARIFF);
export const setDigitalProduct = createAction<WebCatalogDigitalProduct>(DATA_ACTION_TYPES.SET_DIGITAL_PRODUCT);
export const setPaymentFreeBonus = createAction<boolean>(DATA_ACTION_TYPES.SET_PAYMENT_FREE_BONUS);